/**
 * @file 新手指南数据
 * @author FengGuang(fengguang01@baidu.com)
 */

export interface IGuidesItem {
    title: string;
    text: string;
    img: string;
    link: string;
    tagText: string;
}

const guidesData: IGuidesItem[] = [
    {
        title: '零基础教程',
        text: '本教程为没有深度学习技术基础的开发者提供系统的新手课程，飞桨带您从零开始深度学习开发之旅',
        img: '',
        link: '/tutorials',
        tagText: '查看学习资源'
    },
    {
        title: '产业级教程',
        text: '如果你已经掌握了深度学习技术的基础知识，期望通过深度学习模型部署解决实际业务问题，本教程将带你深度了解飞桨产业级实践',
        img: '',
        link: '/tutorials/projectdetail/2538214',
        tagText: '查看进阶指南'
    }
];

export default guidesData;
